import { Component, OnDestroy, OnInit } from '@angular/core';
import { ListItemRendererComponent } from 'gung-list';
import { CartRow, Product, CartRowPrice, Availability, CartService, GungFlowService, AuthService } from 'gung-standard';
import { first } from 'rxjs';

export interface SalesCartRow {
  cartRow: CartRow;
  product: Product;
  price: CartRowPrice;
  availability?: Availability;
}

const buildExtraObjectWithValue = (value: any, pathStr: string): any => {
  const path = pathStr.split('.');
  const recursive = (current: {}, pathArr: string[], value: any) => {
    const [first, ...rest] = pathArr;
    if (!first) {
      return value;
    }
    current[first] = recursive({}, rest, value);
    return current;
  };
  return recursive({}, path, value);
};

const resolvePathValue = (value: {}, path: string[]): any | undefined => {
  const [first, ...others] = path;
  if (!first) {
    return value;
  }
  if (!value) {
    return undefined;
  }
  return resolvePathValue(value[first], others);
};
@Component({
    selector: 'cult-sales-cart-row',
    templateUrl: './cult-sales-cart-row.component.html',
    styleUrls: ['./cult-sales-cart-row.component.scss'],
    standalone: false
})
export class CultSalesCartRowComponent extends ListItemRendererComponent<SalesCartRow> {
  isReturnFlow: boolean;
  isSales = false ;
  constructor(protected cartService: CartService, protected gungFlowService: GungFlowService, protected authService: AuthService) {
    super();
    this.gungFlowService
      .getSelectedFlow()
      .pipe(first())
      .subscribe(flow => {
        this.isReturnFlow = flow.isReturnOrder;
      });
    this.authService
      .getRoles()
      .pipe(first())
      .subscribe(roles => {
        this.isSales = roles.indexOf('SALES') !== -1;
      });
  }

  public removeRow(row: SalesCartRow) {
    this.cartService.removeRow(row.cartRow);
  }

  public orEmpty(value: {}, path: string) {
    const str = resolvePathValue(value, path.split('.'));
    return str || '';
  }

  public updateQty(row: SalesCartRow, value: any) {
    // check qty
    const oldQty = row.cartRow.qty;
    if (oldQty === value) {
      return;
    }
    const step = Math.trunc(row.product.extra.ar?.artfsgforp) || 1;
    if (step !== 1 && value !== '0' && !this.isSales) {
      value = value - (value % step);
      if (value === 0) {
        value = step;
      }
    }
    value = Number(value);
    // value has changed, propagate throught the cart
    this.cartService.setProductQuantity(row.cartRow.productId, value, row.cartRow.targetStockId);
  }

  public updateExtraField(row: SalesCartRow, value: any, path: string) {
    // TODO check if value is the same as before
    if (value !== 0 && !value) {
      this.cartService.removeExtraField(row.cartRow.productId, path, row.cartRow.targetStockId);
      return;
    }
    const extraObj = buildExtraObjectWithValue(value, path);
    this.cartService.setExtra(row.cartRow.productId, extraObj, row.cartRow.targetStockId);
  }
}
